module.exports = __webpack_public_path__ + "img/youtube.1fe436a8.svg";